import _ from 'lodash'

export const optionalPath = p => (p ? `${p}/` : '')
export const getMatchParameter = (match, paramName) => _.get(match, ['params', paramName])
export const getMatchParameterInteger = _.flow(getMatchParameter, _.toInteger)